import { createApp, h, nextTick, ref } from 'vue'
import ElementPlus from 'element-plus'
import MessageConfirm from './message-confirm.vue'
import { $t } from '@/i18n'

/**
 * 显示一个全局确认弹窗
 * @param {string|VNODE} message - 弹窗提示内容
 * @param {string} [title='提示'] - 弹窗标题
 * @param {object} [options={}] - 可选参数
 * @param {string?} [options.confirmText='确认'] - 确认按钮文字
 * @param {string?} [options.cancelText='取消'] - 取消按钮文字
 * @param {'success'|'warning'|'danger'|'info'} [options.type='warning'] - 弹窗类型（影响按钮颜色）
 * @returns {Promise<boolean>} - 用户点击“确认”时 resolve，点击“取消”时 reject
 */
const confirm = (title, message, options) => {
  const defaultOptions = {
    confirmText: $t('commonComponents.ConfirmText'), // 默认确认文本
    ...options           // 覆盖默认值
  }

  // 创建 DOM 挂载点
  const mountNode = document.createElement('div')
  document.body.appendChild(mountNode)

  const modalRef = ref()

  const app = createApp({
    setup() {
      return () => h(MessageConfirm, { ref: modalRef })
    }
  })
  app.use(ElementPlus)
  app.mount(mountNode)

  return nextTick().then(() => {
    if (!modalRef.value || !modalRef.value.show) {
      throw new Error('ConfirmDialog instance not available')
    }

    return modalRef.value.show(message, title, defaultOptions).finally(() => {
      // 卸载组件并清理 DOM
      app.unmount()
      document.body.removeChild(mountNode)
    })
  })
}

export default {
  install(app) {
    app.config.globalProperties.$confirm = confirm
    window.$confirm = confirm
  }
}
